import React from 'react'
import Select, { components } from 'react-select'
import className from 'classnames'

const customStyles = {
  option: (provided) => ({
    ...provided,
    padding: '4px 12px',
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#4a4a4a;' : '#9e9e9e',
    color: '#fff',
    border: 'none',
    boxShadow: 'none',
    minHeight: 28,
    cursor: 'pointer',
    ':hover': {
      ...provided[':hover'],
      backgroundColor: '#787878',
    },
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 2,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#fff',
    whiteSpace: 'nowrap',
    width: '90px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  }),
  singleValue: (provided) => ({
    ...provided,
    backgroundColor: 'unset',
    color: '#fff',
    left: 8,
    right: 8,
    paddingRight: 19,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
    cursor: 'pointer',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'red',
  }),
}

const SingleValue = ({ children, ...props }) => {
  const { clearValue } = props
  return (
    <components.SingleValue {...props}>
      {children}
      <i
        className='fa fa-times post-form__labeles-clear-icon'
        onClick={(e) => {
          e.stopPropagation()
          e.nativeEvent.stopImmediatePropagation()
          clearValue()
        }}
      />
    </components.SingleValue>
  )
}

export const DropdownIndicator = (props) => {
  const { selectProps = {} } = props
  const { menuIsOpen = false, value } = selectProps

  const iconClassName = className(
    menuIsOpen ? 'fas fa-sort-up post-form__label-dropdown-indicator' : 'fas fa-sort-down'
  )

  if (value) {
    return null
  }

  return (
    <components.DropdownIndicator {...props}>
      <i className={iconClassName} />
    </components.DropdownIndicator>
  )
}

const LabelsSelector = ({ options, value, placeholder, className, onChange }) => (
  <Select
    options={options}
    value={value}
    onChange={onChange}
    placeholder={placeholder}
    className={className}
    styles={customStyles}
    isSearchable={false}
    isClearable={false}
    components={{
      DropdownIndicator,
      SingleValue,
    }}
  />
)

export default LabelsSelector
